import { Box, Center, HStack, Img, Text } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { resolveWeatherIconCode } from '../../../../../util/weatherCodeMapper';

export default function WeatherHeader(props) {
  const {
    localityName,
    stateName,
    weatherCode,
    weatherDescription,
    temperature,
    period,
    passingTime,
  } = props;

  const { t, i18n } = useTranslation();
  const [image, setImage] = useState('');

  const passingLabel =
    passingTime instanceof Date && !isNaN(passingTime)
      ? passingTime.toLocaleTimeString(i18n.language || 'es', {
          hour: '2-digit',
          minute: '2-digit',
        })
      : null;

  useEffect(() => {
    if (weatherCode) {
      const iconCode = resolveWeatherIconCode(weatherCode, period);
      import(`../../../../../assets/weathericons/${iconCode}_g.png`)
        .then(img => setImage(img.default))
        .catch(e => console.error(e));
    }
  }, [weatherCode, period]);

  return (
    <Box textAlign={'center'}>
      <Text textStyle={'weatherCardProvincia'}>{stateName}</Text>
      <Text textStyle={'weatherCardLocalidad'} color={'#242424'}>
        {localityName}
      </Text>
      {passingLabel && (
        <Center>
          <HStack spacing={1} color="gray.500" mt={1}>
            <Clock size={12} />
            <Text fontSize="xs">
              {t('map.cards.passingTime', { time: passingLabel })}
            </Text>
          </HStack>
        </Center>
      )}
      <Center my={1}>
        {image && (
          <Img
            w={'70px'}
            h={'70px'}
            src={image}
            alt="Weather Icon"
            style={{ filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.18))' }}
          />
        )}
      </Center>
      <Text fontSize="xs" color="gray.500" mb={1}>{weatherDescription}</Text>
      <Text fontSize="2xl" fontWeight="semibold" color="#242424" lineHeight={1}>
        {temperature}ºC
      </Text>
    </Box>
  );
}
